import {ITrailerJson} from "../../../../../../nodeserver/structs/database";
import JSX from "../../../helpers/react.js";
import RefObject = JSX.RefObject;
import {OneTrailerEdit} from "./OneTrailerEdit.js";

function deepEqual(x: any, y: any): boolean {
    const ok = Object.keys, tx = typeof x, ty = typeof y;
    return x && y && tx === 'object' && tx === ty ? (
        ok(x).length === ok(y).length &&
        ok(x).every(key => deepEqual(x[key as any], y[key as any]))
    ) : (x === y);
}
export function TrailersEditPage({trailers}: {trailers: ITrailerJson[]}){
    const inputs: RefObject<HTMLInputElement> = {};
    const container: RefObject = {};
    let newTrailers = trailers.map(e=>({...e}));
    return (
        <div>
            <input className="inputs hidden" ref={inputs} type="hidden" value="" name="trailers_edit"/>
            <div ref={container}>
                {trailers.map(trailer=>
                    <OneTrailerEdit
                        onChange={(key, value)=>{
                            (newTrailers.find(e=>e.trailer_id === trailer.trailer_id) as any)![key] = value;
                            rebuildInputs(inputs, trailers, newTrailers);
                        }}
                        number={trailer.number}
                        dubbing={trailer.dubbing}
                        player={trailer.player}
                        iframe_url={trailer.iframe_url}
                        onDelete={function(this: HTMLElement){
                            newTrailers = newTrailers.filter(e=>e.trailer_id !== trailer.trailer_id);
                            this.remove();
                            rebuildInputs(inputs, trailers, newTrailers);
                        }}
                    />
                )}
            </div>
            <div className="add-btn" onClick={addElement} style="text-align: center;font-size: 29px;font-weight: bold;cursor: pointer;">+</div>
        </div>
    )
    function addElement(){
        const newTrailer: ITrailerJson = {
            trailer_id: 0,
            iframe_url: '',
            player: '',
            dubbing: '',
            number: '',
            anime_id: page_id!
        };
        newTrailers.push(newTrailer);
        container.value!.appendChild(
            <OneTrailerEdit
                onChange={(key, value) => {
                    (newTrailer as any)[key] = value;
                    rebuildInputs(inputs, trailers, newTrailers);
                }}
                number={newTrailer.number}
                dubbing={newTrailer.dubbing}
                player={newTrailer.player}
                iframe_url={newTrailer.iframe_url}
                onDelete={function (this: HTMLElement) {
                    this.remove();
                    newTrailers = newTrailers.filter(e => e !== newTrailer);
                    rebuildInputs(inputs, trailers, newTrailers);
                }}/> as Node
        );
    }
}
function rebuildInputs(input: RefObject<HTMLInputElement>, oldTrailers: ITrailerJson[], newTrailers: ITrailerJson[]){
    const addedTrailers = newTrailers.filter(e=>e.trailer_id === 0);
    const editedTrailers = newTrailers.filter(e=>{
        if(e.trailer_id === 0) return false;
        const oldTrailer = oldTrailers.find(old=>old.trailer_id === e.trailer_id)!;
        return !deepEqual(oldTrailer, e);
    });
    const deletedTrailers = oldTrailers.filter(old=>newTrailers.findIndex(e=>e.trailer_id===old.trailer_id) === -1)
    const ans = {
        new: addedTrailers,
        edit: editedTrailers,
        delete: deletedTrailers
    };
    input.value!.value = JSON.stringify(ans);
    console.log(ans);

}